module.exports = __webpack_public_path__ + "static/media/Capital-Plus.96295f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Capital-Plus.png
// module id = 420
// module chunks = 0